module.exports = __webpack_public_path__ + "static/media/pots.3ecab86b.jpg";